"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIrrigationPublishTimeRange = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const irrigationScheduler_1 = require("./irrigationScheduler");
const offsetMinutesOfStartTimeByVendor = {
    altrac: 12,
    wiseconn: 10,
};
const isValidControlProvider = (name) => {
    return Object.keys(offsetMinutesOfStartTimeByVendor).includes(name);
};
const getIrrigationPublishTimeRange = ({ controlProviderName, timezone, }) => {
    let startOffset = 0;
    if (controlProviderName) {
        const name = controlProviderName.toLowerCase();
        if (isValidControlProvider(name)) {
            startOffset = offsetMinutesOfStartTimeByVendor[name];
        }
    }
    return {
        dateFromMoment: moment_timezone_1.default.tz(timezone).add(startOffset, 'minutes'),
        dateToMoment: moment_timezone_1.default
            .tz(timezone)
            .day(irrigationScheduler_1.IRRIGATION_SCHEDULER_FIRST_DAY_OF_WEEK)
            .startOf('day')
            .add(30, 'days')
            .endOf('day'),
    };
};
exports.getIrrigationPublishTimeRange = getIrrigationPublishTimeRange;
//# sourceMappingURL=getIrrigationPublishTimeRange.js.map